import styled from 'styled-components';
import { Icon } from '../icon';
import { getColorShade, getColor } from '../../../src/styled/utils';
export const DropdownIndicatorIcon = styled(Icon).attrs({ name: 'keyboard_arrow_down' }) `
  display: ${({ selectProps }) => (selectProps.isDisabled ? 'none' : 'block')};
  transform: ${({ selectProps }) => (selectProps.menuIsOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
  cursor: pointer;

  & > path {
    fill: ${getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
export const SelectedIcon = styled(Icon).attrs({ name: 'check' }) `
  margin-left: auto;
  font-size: 14px;

  & > path {
    fill: ${getColor('primary')};
  }
`;
